import { render, staticRenderFns } from "./TgPanel.vue?vue&type=template&id=892bcdf0"
import script from "./TgPanel.vue?vue&type=script&lang=js"
export * from "./TgPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports